import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { motion as Motion } from "framer-motion";
import api from "@/utils/axios";
import i18n from "@/i18n";

import PortalIconMini from "@/components/icons/PortalIconMini";
import cls from "./VerifyEmailChange.module.scss";

const fade = {
  hidden: { opacity: 0, y: 18 },
  show: { opacity: 1, y: 0, transition: { duration: 0.45 } },
};

const VerifyEmailChange = () => {
  const [params] = useSearchParams();
  const token = params.get("token");
  const lang = params.get("lang") || "en";

  const [loading, setLoading] = useState(true);
  const [done, setDone] = useState(false);
  const [failed, setFailed] = useState(false);
  const [message, setMessage] = useState("");

  useEffect(() => {
    const run = async () => {
      try {
        const { data } = await api.get(
          `/v1/member/profile/verify-email-change?token=${encodeURIComponent(
            token,
          )}`,
        );

        setDone(true);
        setMessage(
          data?.message || i18n.t("verifyEmailChange.messages.success"),
        );
      } catch (err) {
        setFailed(true);
        setMessage(
          err?.response?.data?.message ||
            i18n.t("verifyEmailChange.messages.failed"),
        );
      } finally {
        setLoading(false);
      }
    };

    if (token) {
      run();
    } else {
      setFailed(true);
      setLoading(false);
      setMessage(i18n.t("verifyEmailChange.messages.noToken"));
    }
  }, [token, lang]);

  return (
    <div className={cls.page}>
      <Motion.div
        className={cls.box}
        variants={fade}
        initial="hidden"
        animate="show"
      >
        <div className={cls.badge}>
          <PortalIconMini size={22} />
          <span>{i18n.t("verifyEmailChange.badge")}</span>
        </div>

        <h1 className={cls.title}>
          {loading
            ? i18n.t("verifyEmailChange.titles.verifying")
            : done
              ? i18n.t("verifyEmailChange.titles.success")
              : i18n.t("verifyEmailChange.titles.failed")}
        </h1>

        <p className={cls.message}>{message}</p>

        {!loading && done && (
          <Link to="/login" className={cls.btn}>
            {i18n.t("verifyEmailChange.actions.goToLogin")}
          </Link>
        )}

        {!loading && failed && (
          <Link to="/member/my-profile/login-info" className={cls.btnAlt}>
            {i18n.t("verifyEmailChange.actions.backToSettings")}
          </Link>
        )}

        {loading && <div className={cls.loader} />}
      </Motion.div>

      <div className={cls.bgGlow} />
    </div>
  );
};

export default VerifyEmailChange;
